<template>
  <div class="flex-column">
    <div
      class="primary"
      style="padding: 14px 1.5px !important"
      v-if="staff.position_rank > 1"
    />
    <v-avatar
      circle
      size="75"
      class="grey lighten-5"
      style="border: 2px solid #13aa52 !important"
    >
      <img :src="staff.image" />
    </v-avatar>
    <router-link
      class="primary--text my-2 font-weight-bold"
      :to="`${staff.type}s/${staff.id}?type=${staff.type}`"
    >
      {{ staff.full_name }}
    </router-link>
    <h5 class="font-weight-medium">
      {{ $t("position") }}: {{ staff.position }}
    </h5>
    <h5 class="font-weight-medium">
      {{ $t("join_date") }}:
      {{ staff.hire_date | persianDateFilter(true) }}
    </h5>
    <!-- <h3 class="body-1 font-weight-medium">
          {{$t('phones')}}:  {{ staff.pretty_phone }}
        </h3> -->
  </div>
</template>
<script>
export default {
  props: {
    staff: { default: () => {} },
  },
};
</script>